export default "/assets/e961bdb476db6860f20ff571a84a55b0.woff";